var _defs, _rect, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLargePro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 1,
    y1: 0,
    x2: 0.10282325744628906,
    y2: 0.9364910125732422,
    id: "master_svg0_288_7730"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF6812",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFD25E",
    stopOpacity: 1
  })))), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    rx: 8,
    fill: "url(#master_svg0_288_7730)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.77143,8L5,14.0739L15.6667,26.2857L15.6667,8L8.77143,8Z",
    fillRule: "evenodd",
    fill: "#FFFFFF",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,52.666015625,0)",
    style: {
      opacity: 0.800000011920929
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1044378125,8L26.3330078125,14.0739L36.9997078125,26.2857L36.9997078125,8L30.1044378125,8Z",
    fillRule: "evenodd",
    fill: "#FFEBD6",
    fillOpacity: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLargePro);
export default __webpack_public_path__ + "static/media/icon-large-pro.b497b4e6.svg";
export { ForwardRef as ReactComponent };